import { render } from "./HealthCheckView.vue?vue&type=template&id=65697ad4&scoped=true"
import script from "./HealthCheckView.vue?vue&type=script&lang=js"
export * from "./HealthCheckView.vue?vue&type=script&lang=js"

import "./HealthCheckView.vue?vue&type=style&index=0&id=65697ad4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65697ad4"]])

export default __exports__